module.exports = __webpack_public_path__ + "img/amecameca.cfd1dd04.jpg";